// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"0475df52","63":"77351dfe","165":"41ad96c7","185":"575c772d","186":"45800dd5","208":"9d01bed9","321":"fc97b1ae","328":"830395d0","389":"00c96453","569":"ff371cfb","587":"edcd805a","597":"24ecb121","630":"0bd956eb","865":"b2d6e922","980":"236dd10f"}[chunkId] + ".chunk.js";
};